export function venueRoomLabel(room) {
	if (!room) return '—';
	return room.effectiveDisplayName ?? room.displayName ?? room.name ?? '—';
}

export function roomLabelForSystemName(tables, systemRoom) {
	if (!systemRoom || !Array.isArray(tables)) return systemRoom ?? '—';
	const table = tables.find((t) => t.room === systemRoom);
	return table?.roomLabel ?? systemRoom;
}
